module.exports = __webpack_public_path__ + "img/gallery-image-01.4a3fc800.png";